import React, { useContext } from "react";
import style from "./index.module.scss";
import { Link } from "react-router-dom";
import { date2WeekHanzi, isTrue } from "service/service";
import moment from "moment";
import { homeworkEditUrl, homeworkReviewUrl } from "service/url";
import { CourseContext } from "../../../Store";
import { WeekTimePaper } from "../../../../../service/homework";

interface HomeworkListItemProps {
    data: WeekTimePaper;
}

export default function HomeworkListItem({ data }: HomeworkListItemProps) {
    const { workStatus, endTime } = data;
    const { course } = useContext(CourseContext);

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                {data.paperName}
                {workStatus === "1" && <i className={style.publish}>已发布</i>}
                {workStatus === "0" && (
                    <i className={style.unPublish}>待发布</i>
                )}
            </h1>

            <div className={style.info}>
                课程时间 {moment(course.date).format("YYYY/MM/DD")}{" "}
                {date2WeekHanzi(course.date)}
                {endTime && (
                    <span>
                        ｜ 截止时间{" "}
                        {moment(endTime).format("YYYY/MM/DD HH:mm:ss")}
                    </span>
                )}{" "}
                ｜ {data?.lastEditTeacher}
            </div>

            <div className={style.links}>
                {workStatus === "1" && !isTrue(data.readOnly) && (
                    <Link
                        to={homeworkReviewUrl({
                            ...course,
                            weekTime: course.week,
                            week: course.day
                        })}>
                        批作业
                    </Link>
                )}
                <Link
                    to={homeworkEditUrl({
                        ...course,
                        weekTime: course.week,
                        week: course.day
                    })}>
                    {isTrue(data.readOnly) ? "查看作业" : "留作业"}
                </Link>
            </div>
        </div>
    );
}
